import { Component, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TooltipDirective, TooltipPosition } from '../../../../core/directives/tooltip';
import { IErrorMessage } from '../../../../core/types/general';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-text-area',
  imports: [MatFormFieldModule, MatInputModule, TranslateModule, FormsModule, ReactiveFormsModule, NgClass, MatIcon, TooltipDirective],
  templateUrl: './text-area.component.html',
  styleUrl: './text-area.component.scss',
})
export class TextAreaComponent {
  className = input.required<string>();
  textAreaControl = input.required<FormControl>();
  textAreaRowsMin = input.required<number>();
  textAreaRowsMax = input.required<number>();
  label = input<string>();
  placeholder = input<string>();
  readonly = input<boolean>(false);
  errorMessages = input<IErrorMessage[]>([]);
  hintMessage = input<string>();
  hideRequiredMarker = input<boolean>(false);
  infoTooltip = input<string | null>('');
  protected readonly Validators = Validators;
  protected readonly TooltipPosition = TooltipPosition;

  getFirstError() {
    return this.errorMessages().find((e) => this.textAreaControl().hasError(e.errorName) && this.textAreaControl().touched);
  }
}
